class CompleteLook extends HTMLElement {
  constructor() {
    super();
    console.log('Complete the look: Started');

    this.form = this.querySelector('form');
    this.selectElems = this.querySelectorAll('select');

    if (!this.form) {
      this.handleMessage('Missing form', 'banner--error');
      return;
    }
  }

  connectedCallback() {
    for (const select of [...this.selectElems]) {
      select.addEventListener('change', (e) => this.setProductValues(e));
    }
    this.form.addEventListener('submit', (e) => this.handleEvent(e));
  }

  disconnectedCallback() {
    for (const select of [...this.selectElems]) {
      select.removeEventListener('change', (e) => this.setProductValues(e));
    }
    this.form.removeEventListener('submit', (e) => this.handleEvent(e));
  }

  setProductValues(evt) {
    if (!evt || !evt.target || !evt.target.closest('.product-item')) {
      return;
    }

    const { target } = evt;
    const parent = target.closest('.product-item');
    const selectedOption = target.options[target.selectedIndex];

    const checkbox = parent.querySelector('input[type="checkbox"]');
    if (checkbox) {
      checkbox.value = selectedOption.value;
    }

    const price = parent.querySelector('.product-price');
    if (price) {
      price.innerHTML = selectedOption.dataset.price
    }
  }

  async handleEvent(evt) {
    if (!evt) {
      return;
    }

    evt.preventDefault();

    const banner = this.querySelector('.banner');
    if (banner) {
      banner.classList.remove('banner--error', 'banner--success');
      banner.classList.add('hidden');
      banner.innerHTML = '';
    }

    const selectedProducts = [...this.form.elements].filter(elem => elem.type === "checkbox" && elem.checked);
    if (selectedProducts.length === 0) {
      this.handleMessage('No product/s selected.', 'banner--error');
      return;
    }

    const button = this.form.elements["submit"];
    if (button) {
      button.classList.add('button--loading');
    }

    const cartUtils = window.cartUtils || {};
    const enqueue = cartUtils.enqueueCartTask || ((task) => task());
    const getCart2 = cartUtils.getCart || (({ delay = 0 } = {}) => new Promise((resolve, reject) => {
      setTimeout(() => {
        fetch(window.Shopify.routes.root + "cart.js").then((r) => r.json()).then(resolve).catch(reject);
      }, delay);
    }));
    try {
      await enqueue(async () => {
        let sectionsToBundle = [];
        document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
        document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));

        const items = selectedProducts.map(el => ({ id: el.value, quantity: 1 }));
        const req = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            'items': items,
            'sections': sectionsToBundle.join(",")
          })
        });

        document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
        const res = await req.json();

        if (req.status === 422) {
          if (button) {
            button.classList.remove('button--loading');
          }
          this.handleMessage(res.description || res.message, 'banner--error');
          return;
        }

        const cartData = await getCart2({ delay: 150 });
        cartData["sections"] = res["sections"];

        document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
          bubbles: true,
          detail: {
            baseEvent: "variant:add",
            cart: cartData,
            openDrawer: false
          }
        }));

        this.handleMessage('Product/s added to cart', 'banner--success');
        if (button) {
          button.classList.remove('button--loading');
        }
      });
    } catch (error) {
      this.dispatchEvent(new CustomEvent("cart:error", {
        bubbles: true,
        detail: {
          error: error.description
        }
      }));
    }
  }

  handleMessage(message, state = '' ) {
    const banner = this.querySelector('.banner');
    if (banner) {
      banner.classList.add(state);
      banner.classList.remove('hidden');
      banner.innerHTML = message;
    }
    console.log(`Complete the look: ${message}`);
  }
}
if (!customElements.get('complete-look')){
  customElements.define('complete-look', CompleteLook);
}
